import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pod",
  "use": "pod-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"pod\"><path d=\"M7 15h3v-3H7zm4-11-7 6v8h7l7-6V4zm5.5 7.31-6.055 5.19H5.5v-5.81l6.055-5.19H16.5zM15 7h-3v3h3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol